import request from '@/utils/request'

/** 版本列表 */
export function version_get_list(data) {
    return request({
        url: 'version/get_list',
        method: 'get',
        params: data
    })
}

/** 创建/修改版本 */
// http://www.sasscontract.com/adminapi/version/save
export function version_update(data) {
    return request({
        url: '/version/save',
        method: 'post',
        data
    })
}

/** 删除版本 */
export function version_delete(data) {
    return request({
        url: '/version/delete',
        method: 'post',
        data
    })
}

/** 上架/下架版本 status: 1上架 2下架 */
export function version_update_status(data) {
    return request({
        url: '/version/update_status',
        method: 'post',
        data
    })
}

/** 附加功能选项 */
export function get_extra_features(data) {
    return request({
        url: 'version/get_extra_features',
        method: 'get',
        params: data
    })
}

/** 版本权限列表 */
export function version_permission_list(data) {
    return request({
        url: 'version/permission_list',
        method: 'get',
        params: data
    })
}

/** 套餐订单列表 */
export function version_order_list(data) {
    return request({
        url: 'version/order_list',
        method: 'get',
        params: data
    })
}

/** 创建套餐订单 */
export function version_order_add(data) {
    return request({
        url: 'version/order_add',
        method: 'post',
        data
    })
}

/** 编辑套餐订单 */
export function version_order_edit(data) {
    return request({
        url: 'version/order_edit',
        method: 'post',
        data
    })
}

/** 删除套餐订单 */
export function version_order_del(data) {
    return request({
        url: 'version/order_del',
        method: 'post',
        data
    })
}

/** 支付套餐订单 pay_type: 0线下 1线上 */
export function version_order_pay(data) {
    return request({
        url: 'version/order_pay',
        method: 'post',
        data
    })
}

/** 退款 */
export function version_order_refund(data) {
    return request({
        url: 'version/order_refund',
        method: 'post',
        data
    })
}

/** 查询订单支付状态 */
export function version_order_status(data) {
    return request({
        url: 'version/order_status',
        method: 'get',
        params: data
    })
}
